import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dockerHub = defineConnector({
  identifier: "dockerHub",
  name: "Docker Hub",
  tagLine: "Container image registry",
  keywords: "dockerhub containers images registry oci repositories tags",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://hub\\.docker\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://hub.docker.com/v2/users/login",
        jsonBody: {
          username: app.config.username,
          password: app.secret.personalAccessToken,
        },
      },
      extract: { from: "jsonPath", paths: ["token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create a Docker personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Docker Hub, create a personal access token and use it in place of your password for API access.",
        },
      ],
    },
    {
      title: "Enter your Docker Hub details",
      items: [
        {
          kind: "input",
          label: "Docker Hub username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "personalAccessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://hub.docker.com/v2/user/",
  },
});
